// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"948":"cf2a5d0d","4111":"3a39f2d1"}[chunkId] + ".chunk.css";
};